import { useMemo } from 'react';
import { cn } from '@immo/ui-kit';
import { sanitiseEmailHtml } from '@/lib/email/sanitise-email-html';

export type ComposerSignatureProps = {
  // The resolved company signature HTML — our own content, so remote images stay.
  readonly html: string;
  // Horizontal padding matching the composer container, aligned with the body above.
  readonly padX: string;
  // Accessible name of the block (the composer's `signature-label`).
  readonly label: string;
};

export function ComposerSignature({ html, padX, label }: ComposerSignatureProps) {
  const safeHtml = useMemo(() => sanitiseEmailHtml(html, { allowRemoteImages: true }).html, [html]);

  return (
    <div role="group" aria-label={label} className={cn('shrink-0 pb-3 text-base-sm text-text-secondary', padX)}>
      <div aria-hidden className="font-mono text-sm text-text-placeholder">
        {'--'}
      </div>
      <div dangerouslySetInnerHTML={{ __html: safeHtml }} />
    </div>
  );
}
